import _ from 'lodash'
import Backbone from 'backbone'
import template from './filter-dialog.hbs'
import DatasetsFilterBadges from './datasets-filter-badges'
import i18n from 'scoreboard/components/i18n'

var FilterDialog = Backbone.View.extend({

	/** @type {Dataset} */
	model: null,

	/**
	 * A dialog which displays filters
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Dataset} options.model the Dataset
	 *
	 * @param {Object} options.field the field the filters belong to
	 *
	 * @param {Array} options.allFilters all of the filters that could possibly
	 * appear in the dialog; will be narrowed down if options.showAllFilters=false
	 *
	 * @param {Boolean} [options.showAllFilters=false] if set to true, will show
	 * all of the filters in options.allFilters; otherwise, will only show filters
	 * that match options.field
	 *
	 * @param {Object} options.treeItemsById a hash of tree IDs to tree items
	 *
	 * @param {String} [options.dialogHeading] an optional custom
	 * heading for the dialog (defaults to "Filters")
	 *
	 * @param {String} [options.panelHeading] an optional custom heading
	 * for the panel (defaults to "Active Filters")
	 *
	 * @param {String} [options.allowAppCalendar] whether "Current Calendar"
	 * should be an option when working with date filters
	 *
	 * @param {String} [options.section] the section that this dataset is being
	 * displayed in ('dashboards' or 'datasets')
	 *
	 * @param {String} [options.message] optional message to display in a message box
	 */

	 className: 'filter-dialog',

	initialize(options = {}) {
		this.options = options
		this.filters = options.showAllFilters ? options.allFilters
			: _.filter(options.allFilters, f => f.fieldId == this.options.field.id)
	},

	events: {
		'click .add': 'addFilter',
		'click .done': 'done'
	},

	render() {
		this.filterBadges = new DatasetsFilterBadges({
			model: this.model,
			filters: this.filters,
			treeItemsById: this.options.treeItemsById,
			showPermissionFilters: false,
			allowAppCalendar: this.options.allowAppCalendar,
			section: this.options.section
		}).render()
		this.filterBadges.on('all', () => {
			this.$('.button-primary').prop('disabled', false)
		})

		this.$el.empty().append(template(this.context()))
		this.$('.panel-content').append(this.filterBadges.el)
		return this
	},

	context() {
		return _.extend({
			dialogHeading: i18n.get('dashboards.datasets.setFilters'),
			panelHeading: i18n.get('datasets.records.activeFilters')
		}, _.pick(this.options, 'dialogHeading', 'panelHeading', 'message'))
	},

	addFilter() {
		let options = {
			filter: {
				fieldId: this.options.field ? this.options.field.id : null
			},
			lockField: this.options.lockField
		}
		this.filterBadges.addFilter(options)
	},

	done() {
		this.trigger('done', this.filterBadges.filters)
	},

	remove() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.filterBadges], 'remove')
	}

})

export default FilterDialog

FilterDialog.__filename__ = 'datasets/filters/filter-dialog.js'
